import React,{useEffect, useState} from 'react'
import ProjectNav from './ProjectNav'
import InfoSection from './InfoSection'
import FloatingText from './FloatingText'
import { client } from '../client';
import { useParams } from "react-router-dom";



import Footer from './Footer';



const ProjectInfo = () => {


  const [postData, setPostData] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
   client
      .fetch(
        `*[slug.current == $slug]{
          title,
          slug,
          year,
          tag,
          projectType,
          website,
          mainImage{
            asset->{
              _id,
              url
             }
           },
         body,
        "name": author->name,
        "authorImage": author->image
       }`,
        { slug }
      )
      .then((data) => setPostData(data[0]))
      .catch(console.error);
  }, [slug]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className=' overflow-x-hidden'>
        <ProjectNav/>
        {postData && <InfoSection title={postData.title} body={postData.body} image={postData.mainImage.asset.url} year={postData.year} tag={postData.tag} projectType={postData.projectType} website={postData.website} />}
        <FloatingText/>
        <Footer/>
    </div>
  )
}

export default ProjectInfo